module.exports = __webpack_public_path__ + "media/marshall-shepherd.f60eec2e.mp4";